import {MovieService, FilmFestivalService, RegionService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import MetaData from  '../../../mixins/meta-data.js'

export default {
	name: 'film-festival-details',
	mixins: [MetaData],
	data() {
		return {
			loading: true,
			filmFestival: {},
			activeMovie: null,
            movieSummary: null,
            bottomOffset: null,
            selected_cinema_id: null,
			top: 0,
			movies:null
		}
	},

	methods: {
		getAsyncData(){
		    this.metaTitle = this.filmFestival.Name
		    this.metaImage = this.filmFestival.images.poster.url
		    this.metaDescription = this.filmFestival.Description
		    this.schemaDataSrc = {
		        "@context": "http://schema.org",
		        "@type": "Event",
		        "image": this.metaImage,
		        "description": this.metaDescription,
		        // "endDate": ""
		        // "location": {
		        //     "@type": "Place",
		        //     "address": {
		        //         "@type": "​PostalAddress​",
		        //         "addressLocality": "​Denver​",
		        //         "addressRegion": "​CO​",
		        //         "postalCode": "​80209​",
		        //         "streetAddress": "​7 S. Broadway​"
		        //     },
		        //     "name": "​The Hi-Dive​"
		        // },
		        "name": this.metaTitle,
		        // "offers": {
		        //     "@type": "Offer",
		        //     "validFrom": "​2018-10-10​",
		        //     "price": "​13.00​",
		        //     "availability": "http://schema.org/InStock",
		        //     "priceCurrency": "ZAR",
		        //     "url": "​http://www.ticketfly.com/purchase/309433​"
		        // },
		        "startDate": this.filmFestival.StartDate._i
		    }
		    this.$emit('updateHead');
		},
  },

	created() {
		Promise.all([FilmFestivalService.getFilmFestivalById(this.$route.params.id)]).then(
			(filmFestival) => {
				for(var i = 0; i < filmFestival.length; i++)
				{
					this.filmFestival = filmFestival[i];
					// var movies = [];
					// for(var k = 0; k < this.filmFestival.Movies.length; k++) {
					// 	var movie = Promise.resolve(MovieService.getMovieDetail(this.filmFestival.Movies[k].id)).then((movie) => {return movie});
					// 	movies.push(movie);
					// 	console.log(movie);
					// }


					//this.filmFestival.Movies = movies;
				}
				this.getAsyncData()
				this.loading = false;
			},
			(error) => {
				this.filmFestival = undefined
				this.loading = true;
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/film-festivals/film-festivals.js